import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import Grid from '../../../components/molecules/Grid';
import Link from '../../../components/atoms/Link';
import Typography from '../../../components/atoms/Typography';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { get } from 'lodash';
import { COMPONENT_NAME } from './locators';
import useStyles from './style';
import { getComponentName, getPageName } from '../../../utils/getPageComponentInfo';
import { createDynamicLabels } from '../../../../../src/utils/analytics';

const Sitemap = props => {
  const { fields } = props;
  const classes = useStyles();
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);
  if (!fields) {
    return null;
  }

  const { name, url, childItems } = fields;

  const getVariant = (mobVariant, deskVariant) =>
    isMobile ? mobVariant : deskVariant;

  // The configuration starts from Level 2.
  const configArr = [
    {
      listClass: 'l2List',
      variant: getVariant('h5', 'cardTitle1'),
      component: 'p',
    },
    {
      itemClass: 'l3Item',
      variant: getVariant('body2', 'body3'),
      component: 'p',
    },
  ];
  const defaultConfig = {
    variant: 'body1',
    component: 'p',
  };

  // Level = parentIndex + 2
  const createList = (list, parentIndex) => {
    if (list) {
      return list.map((item, index) => {
        // To get the config based on the level.
        let config = configArr[parentIndex] || defaultConfig;
        return (
          <li key={index} className={config.listClass}>
            {createLink(
              item.name,
              item.url,
              config.variant,
              config.component,
              config.itemClass
            )}
            <ul>{createList(item.childItems, parentIndex + 1)}</ul>
          </li>
        );
      });
    }
    return null;
  };

  const createLink = (text, href, variant, component, className) => (
    <Link
      link={{
        value: {
          text,
          href,
        },
      }}
      data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick', '')}
      data-link={createDynamicLabels([getPageName(props), getComponentName(props), `${get(analyticsData,'dataLinksText.siteMapText','')}-${text}`])}
    >
      <Typography
        variant={variant}
        component={component}
        className={clsx(className, classes.link)}
      >
        {text}
      </Typography>
    </Link>
  );

  return (
    name &&
    url && (
      <div className={classes.root} data-locator={COMPONENT_NAME}>
        <Grid>
          {createLink(name, url, getVariant('h2', 'h4'), 'h2')}
          <Grid container>
            {childItems &&
              childItems.map((l1Item, index) => (
                <Grid
                  item
                  xs={12}
                  lg={3}
                  className={classes.l1List}
                  key={index}
                >
                  {createLink(
                    l1Item.name,
                    l1Item.url,
                    getVariant('h3', 'h5Bold'),
                    'h3'
                  )}
                  <ul>{createList(l1Item.childItems, 0)}</ul>
                </Grid>
              ))}
          </Grid>
        </Grid>
      </div>
    )
  );
};

Sitemap.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    childItems: PropTypes.any.isRequired,
  }),
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(Sitemap))
);
